import React from "react";
import "./Description.css"

const Description = () => {
    return(
        <div className="descriptionSection">
            <h3 className="sectionTitle">Descripción</h3>
            <p className="descriptionDescription">Bryan es un desarrollador fullstack jr con sede en México con una pasión por crear servicios digitales/aplicaciones. Tiene una habilidad especial para la resolución de problemas de la vida real con código y todo lo relacionado con el lanzamiento de productos, desde la planificación y el diseño. Cuando no está en programando, le encanta pasar el rato con su familia. Actualmente, vive de su trabajo.</p>
        </div>
    )
}
export default Description